import {
  DealPayrollChecklistKind, DealPayrollClassificationSource,
  DealPayrollCoefficientUnitType, DealPayrollEmployeeRoleCode,
  DealPayrollFormulaVersion, DealPayrollGradeCode, DealPayrollProfile,
  DealPayrollIssue, DealPayrollTaskLine, DealPayrollTaskRuleCode,
  isFinitePayrollNumber
} from './deal-payroll.model';

const GENERIC_ISSUE_KEY = 'DEAL_PAYROLL_ISSUE_GENERIC';
const GRADE_KEY_PREFIX = 'DEAL_PAYROLL_GRADE_';
const TASK_RULE_KEY_PREFIX = 'DEAL_PAYROLL_TASK_RULE_';
const CLASSIFICATION_SOURCE_KEY_PREFIX = 'DEAL_PAYROLL_CLASSIFICATION_SOURCE_';
const COEFFICIENT_UNIT_TYPE_KEY_PREFIX = 'DEAL_PAYROLL_COEFFICIENT_UNIT_TYPE_';
const CHECKLIST_KIND_KEY_PREFIX = 'DEAL_PAYROLL_CHECKLIST_KIND_';
const EMPLOYEE_ROLE_KEY_PREFIX = 'DEAL_PAYROLL_EMPLOYEE_ROLE_';
const PROFILE_KEY_PREFIX = 'DEAL_PAYROLL_PROFILE_';
const FORMULA_KEY_PREFIX = 'DEAL_PAYROLL_FORMULA_';
const EMPTY_KEY = '';
const GENERIC_ACTION_KEY = 'DEAL_PAYROLL_ISSUE_ACTION_CONTACT_PAYROLL';
const EFFECT_NOT_COUNTED_KEY = 'DEAL_PAYROLL_ISSUE_EFFECT_NOT_COUNTED';
const EFFECT_COUNTED_KEY = 'DEAL_PAYROLL_ISSUE_EFFECT_COUNTED';
const EFFECT_COUNTED_WITH_ONE_KEY = 'DEAL_PAYROLL_ISSUE_EFFECT_COUNTED_WITH_ONE';
const EFFECT_PAYROLL_UNAVAILABLE_KEY = 'DEAL_PAYROLL_ISSUE_EFFECT_PAYROLL_UNAVAILABLE';
const EFFECT_SOURCE_UNAVAILABLE_KEY = 'DEAL_PAYROLL_ISSUE_EFFECT_SOURCE_UNAVAILABLE';
const RETRY_SOURCE_ACTION_KEY = 'DEAL_PAYROLL_ISSUE_ACTION_RETRY_SOURCE';
const DEFAULTED_PROCESS_CODE = 'PROCESS_RULE_DEFAULTED';
const FIRST_ISSUE_CODE_INDEX = 0;
const COEFFICIENT_ONE_ISSUE_CODES = [
  DEFAULTED_PROCESS_CODE,
  'AREA_MISSING',
  'AREA_AMBIGUOUS',
  'AREA_UNCONFIRMED',
  'CONSTRUCTION_TEAM_AMBIGUOUS',
  'CONSTRUCTION_TEAM_UNSUPPORTED',
  'CONSTRUCTION_ROLE_MALFORMED',
  'CONSTRUCTION_ROLE_CONFLICT',
  'CONSTRUCTION_ROLE_DEPTH_EXCEEDED',
  'TASK_GRADE_MISSING', 'TASK_GRADE_UNKNOWN', 'TASK_GRADE_CONFLICT', 'TASK_GRADE_COEFFICIENT_MISSING'
];
const BLOCKER_KEYS: {[code: string]: string} = {
  BUSINESS_TRIP_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_BUSINESS_TRIP_COEFFICIENT_INVALID',
  MANDATORY_TRAINING_REQUIRED: 'MANDATORY_TRAINING_REQUIRED',
  GRADE_TRAINING_PERCENTAGE_REQUIRED: 'GRADE_TRAINING_PERCENTAGE_REQUIRED',
  GROWTH_TRAINING_CONTEXT_UNAVAILABLE: 'GROWTH_TRAINING_CONTEXT_UNAVAILABLE',
  PROBATION_NOT_PASSED: 'PROBATION_NOT_PASSED',
  COMPANY_TRAINING_REQUIRED: 'COMPANY_TRAINING_REQUIRED',
  GRADE_IN_USE: 'DEAL_PAYROLL_GRADE_IN_USE',
  ENABLED_GRADE_REQUIRED: 'DEAL_PAYROLL_ENABLED_GRADE_REQUIRED',
  BASE_MONTHLY_SALARY_INVALID: 'DEAL_PAYROLL_MONTHLY_BASE_INVALID',
  OBSOLETE_PAYROLL_SETTINGS_REFRESH_REQUIRED: 'DEAL_PAYROLL_SETTINGS_STALE',
  MONTHLY_BASE_REQUIRED: 'DEAL_PAYROLL_MONTHLY_BASE_INVALID',
  MONTH_NORM_REQUIRED: 'DEAL_PAYROLL_MONTH_NORM_UNAVAILABLE',
  PLAN_FACT_WEIGHT_INVALID: 'DEAL_PAYROLL_WEIGHT_INVALID',
  PLANNED_WEIGHT_INVALID: 'DEAL_PAYROLL_WEIGHT_INVALID',
  PENDING_PAYROLL_POLICY_CHANGED: 'PAYROLL_PENDING_POLICY_CHANGED',
  DEPARTMENT_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_DEPARTMENT_NOT_CONFIGURED',
  DEPARTMENT_POLICY_REQUIRED: 'DEAL_PAYROLL_BLOCKER_DEPARTMENT_POLICY_REQUIRED',
  EMPLOYEE_ASSIGNMENT_REQUIRED: 'DEAL_PAYROLL_BLOCKER_ASSIGNMENT_REQUIRED',
  PAYROLL_POSITION_REQUIRED: 'DEAL_PAYROLL_BLOCKER_POSITION_REQUIRED',
  PAYROLL_GRADE_REQUIRED: 'DEAL_PAYROLL_BLOCKER_GRADE_REQUIRED',
  PAYROLL_POLICY_FIELDS_REQUIRED: 'DEAL_PAYROLL_BLOCKER_POLICY_FIELDS_REQUIRED',
  PAYROLL_POSITION_IN_USE: 'DEAL_PAYROLL_BLOCKER_POSITION_IN_USE',
  ASSIGNMENT_FIELDS_NOT_ALLOWED: 'DEAL_PAYROLL_BLOCKER_ASSIGNMENT_FIELDS_NOT_ALLOWED'
};
const ISSUE_KEYS: {[code: string]: string} = {
  BASE_MONTHLY_SALARY_INVALID: 'DEAL_PAYROLL_MONTHLY_BASE_INVALID',
  PLANNED_WEIGHT_INVALID: 'DEAL_PAYROLL_WEIGHT_INVALID',
  OBSOLETE_PAYROLL_SETTINGS_REFRESH_REQUIRED: 'DEAL_PAYROLL_SETTINGS_STALE',
  MONTHLY_BASE_REQUIRED: 'DEAL_PAYROLL_MONTHLY_BASE_INVALID',
  MONTH_NORM_REQUIRED: 'DEAL_PAYROLL_MONTH_NORM_UNAVAILABLE',
  PLAN_FACT_WEIGHT_INVALID: 'DEAL_PAYROLL_WEIGHT_INVALID',
  TASK_GRADE_MISSING: 'DEAL_PAYROLL_ISSUE_TASK_GRADE_MISSING',
  TASK_GRADE_UNKNOWN: 'DEAL_PAYROLL_ISSUE_TASK_GRADE_UNKNOWN',
  TASK_GRADE_CONFLICT: 'DEAL_PAYROLL_ISSUE_TASK_GRADE_CONFLICT',
  TASK_GRADE_COEFFICIENT_MISSING: 'DEAL_PAYROLL_ISSUE_TASK_GRADE_COEFFICIENT_MISSING',
  DEAL_SNAPSHOT_MISSING: 'DEAL_PAYROLL_SNAPSHOT_MISSING',
  DEAL_DISABLED: 'DEAL_PAYROLL_ISSUE_DEAL_DISABLED',
  DEAL_BUSY: 'DEAL_PAYROLL_ISSUE_DEAL_BUSY',
  DEAL_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_DEAL_NOT_CONFIGURED',
  DEAL_DEADLINE_EXCEEDED: 'DEAL_PAYROLL_ISSUE_PLANFIX_TIMEOUT',
  DEAL_FULL_MONTH_REQUIRED: 'DEAL_PAYROLL_ISSUE_FULL_MONTH',
  DEAL_UNAVAILABLE: 'DEAL_PAYROLL_ISSUE_DEAL_UNAVAILABLE',
  DEAL_XML_WORKTIME_UNAVAILABLE: 'DEAL_PAYROLL_ISSUE_WORKTIME_UNAVAILABLE',
  DEPARTMENT_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_DEPARTMENT_NOT_CONFIGURED',
  DEPARTMENT_POLICY_REQUIRED: 'DEAL_PAYROLL_ISSUE_DEPARTMENT_POLICY_REQUIRED',
  EMPLOYEE_ASSIGNMENT_REQUIRED: 'DEAL_PAYROLL_ISSUE_EMPLOYEE_ASSIGNMENT_REQUIRED',
  PAYROLL_POSITION_REQUIRED: 'DEAL_PAYROLL_ISSUE_PAYROLL_POSITION_REQUIRED',
  PAYROLL_GRADE_REQUIRED: 'DEAL_PAYROLL_ISSUE_PAYROLL_GRADE_REQUIRED',
  PAYROLL_HISTORY_UNAVAILABLE: 'DEAL_PAYROLL_ISSUE_PAYROLL_HISTORY_UNAVAILABLE',
  MANUFACTURING_GRADE_REQUIRED: 'DEAL_PAYROLL_ISSUE_MANUFACTURING_GRADE_REQUIRED',
  PAYROLL_METHOD_NOT_DEAL: 'DEAL_PAYROLL_ISSUE_PAYROLL_METHOD_NOT_DEAL',
  PLANFIX_REST_ID_REQUIRED: 'DEAL_PAYROLL_ISSUE_PLANFIX_REST_ID_REQUIRED',
  SALARY_REQUIRED: 'DEAL_PAYROLL_ISSUE_SALARY_REQUIRED',
  PLAN_INVALID: 'DEAL_PAYROLL_ISSUE_INVALID_DATA',
  NEGATIVE_PLAN: 'DEAL_PAYROLL_ISSUE_INVALID_DATA',
  NEGATIVE_ACTUAL: 'DEAL_PAYROLL_ISSUE_NEGATIVE_ACTUAL',
  PAYABLE_UNITS_INVALID: 'DEAL_PAYROLL_ISSUE_PAYABLE_UNITS_INVALID',
  ACTUAL_RATE_INVALID: 'DEAL_PAYROLL_ISSUE_ACTUAL_RATE_INVALID',
  GRADE_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_GRADE_COEFFICIENT_INVALID',
  MASTER_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_MASTER_COEFFICIENT_INVALID',
  BUSINESS_TRIP_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_BUSINESS_TRIP_COEFFICIENT_INVALID',
  AREA_REQUIRED: 'DEAL_PAYROLL_ISSUE_AREA_REQUIRED',
  AREA_UNCONFIRMED: 'DEAL_PAYROLL_ISSUE_AREA_UNCONFIRMED',
  ZERO_TOTAL_ACTUAL: 'DEAL_PAYROLL_ISSUE_MISSING_DATA',
  ZERO_PLAN_AND_ACTUAL: 'DEAL_PAYROLL_ISSUE_MISSING_DATA',
  PLANFIX_BUSY: 'DEAL_PAYROLL_ISSUE_PLANFIX_BUSY',
  PLANFIX_INTERRUPTED: 'DEAL_PAYROLL_ISSUE_PLANFIX_INTERRUPTED',
  PLANFIX_DEADLINE_EXCEEDED: 'DEAL_PAYROLL_ISSUE_PLANFIX_TIMEOUT',
  PLANFIX_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_PLANFIX_NOT_CONFIGURED',
  PLANFIX_UNAUTHORIZED: 'DEAL_PAYROLL_ISSUE_PLANFIX_UNAUTHORIZED',
  PLANFIX_FORBIDDEN: 'DEAL_PAYROLL_ISSUE_PLANFIX_FORBIDDEN',
  PLANFIX_RATE_LIMITED: 'DEAL_PAYROLL_ISSUE_PLANFIX_RATE_LIMITED',
  PLANFIX_UNAVAILABLE: 'DEAL_PAYROLL_ISSUE_PLANFIX_UNAVAILABLE',
  PLANFIX_REQUEST_LIMIT: 'DEAL_PAYROLL_ISSUE_PLANFIX_REQUEST_LIMIT',
  PLANFIX_PAGE_LIMIT: 'DEAL_PAYROLL_ISSUE_PLANFIX_PAGE_LIMIT',
  PLANFIX_ITEM_LIMIT: 'DEAL_PAYROLL_ISSUE_PLANFIX_ITEM_LIMIT',
  PLANFIX_RESPONSE_INVALID: 'DEAL_PAYROLL_ISSUE_PLANFIX_RESPONSE_INVALID',
  TASK_MALFORMED: 'DEAL_PAYROLL_ISSUE_TASK_MALFORMED',
  TASK_DUPLICATE_CONFLICT: 'DEAL_PAYROLL_ISSUE_TASK_DUPLICATE_CONFLICT',
  ANALYTICS_MISSING: 'DEAL_PAYROLL_ISSUE_ANALYTICS_MISSING',
  ANALYTIC_MALFORMED: 'DEAL_PAYROLL_ISSUE_ANALYTIC_MALFORMED',
  ANALYTIC_DUPLICATE_CONFLICT: 'DEAL_PAYROLL_ISSUE_ANALYTIC_DUPLICATE_CONFLICT',
  TASK_RECHECK_MISSING: 'DEAL_PAYROLL_ISSUE_TASK_RECHECK_MISSING',
  TASK_NO_LONGER_ELIGIBLE: 'DEAL_PAYROLL_ISSUE_TASK_CHANGED',
  AREA_MISSING: 'DEAL_PAYROLL_ISSUE_AREA_MISSING',
  AREA_AMBIGUOUS: 'DEAL_PAYROLL_ISSUE_AREA_AMBIGUOUS',
  CONSTRUCTION_TEAM_AMBIGUOUS: 'DEAL_PAYROLL_ISSUE_CONSTRUCTION_TEAM_AMBIGUOUS',
  CONSTRUCTION_TEAM_UNSUPPORTED: 'DEAL_PAYROLL_ISSUE_CONSTRUCTION_TEAM_UNSUPPORTED',
  CONSTRUCTION_ROLE_MALFORMED: 'DEAL_PAYROLL_ISSUE_CONSTRUCTION_ROLE_MALFORMED',
  CONSTRUCTION_ROLE_CONFLICT: 'DEAL_PAYROLL_ISSUE_CONSTRUCTION_ROLE_CONFLICT',
  CONSTRUCTION_ROLE_DEPTH_EXCEEDED: 'DEAL_PAYROLL_ISSUE_CONSTRUCTION_ROLE_DEPTH_EXCEEDED',
  PROCESS_RULE_DEFAULTED: 'DEAL_PAYROLL_ISSUE_PROCESS_RULE_DEFAULTED',
  UNSUPPORTED_PROCESS: 'DEAL_PAYROLL_ISSUE_UNSUPPORTED_PROCESS'
};
const ISSUE_ACTION_KEYS: {[code: string]: string} = {
  BASE_MONTHLY_SALARY_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PLANNED_WEIGHT_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  OBSOLETE_PAYROLL_SETTINGS_REFRESH_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_REFRESH',
  MONTHLY_BASE_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  MONTH_NORM_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_NORM',
  PLAN_FACT_WEIGHT_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  TASK_GRADE_MISSING: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TASK_GRADE',
  TASK_GRADE_UNKNOWN: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TASK_GRADE',
  TASK_GRADE_CONFLICT: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TASK_GRADE',
  TASK_GRADE_COEFFICIENT_MISSING: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  DEAL_SNAPSHOT_MISSING: 'DEAL_PAYROLL_ISSUE_ACTION_REFRESH',
  DEAL_DISABLED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PLAN_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TIME',
  NEGATIVE_PLAN: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TIME',
  NEGATIVE_ACTUAL: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TIME',
  PAYABLE_UNITS_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TIME',
  ZERO_TOTAL_ACTUAL: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TIME',
  ZERO_PLAN_AND_ACTUAL: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TIME',
  ACTUAL_RATE_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  GRADE_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  MASTER_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  BUSINESS_TRIP_COEFFICIENT_INVALID: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  ANALYTICS_MISSING: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_ANALYTICS',
  ANALYTIC_MALFORMED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_ANALYTICS',
  ANALYTIC_DUPLICATE_CONFLICT: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_ANALYTICS',
  AREA_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_AREA',
  AREA_UNCONFIRMED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_AREA',
  AREA_MISSING: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_AREA',
  AREA_AMBIGUOUS: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_AREA',
  CONSTRUCTION_TEAM_AMBIGUOUS: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_CONSTRUCTION',
  CONSTRUCTION_TEAM_UNSUPPORTED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_CONSTRUCTION',
  CONSTRUCTION_ROLE_MALFORMED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_CONSTRUCTION',
  CONSTRUCTION_ROLE_CONFLICT: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_CONSTRUCTION',
  CONSTRUCTION_ROLE_DEPTH_EXCEEDED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_CONSTRUCTION',
  TASK_MALFORMED: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TASK',
  TASK_DUPLICATE_CONFLICT: 'DEAL_PAYROLL_ISSUE_ACTION_FIX_TASK',
  TASK_RECHECK_MISSING: 'DEAL_PAYROLL_ISSUE_ACTION_REFRESH',
  TASK_NO_LONGER_ELIGIBLE: 'DEAL_PAYROLL_ISSUE_ACTION_REFRESH',
  PROCESS_RULE_DEFAULTED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_RULE',
  UNSUPPORTED_PROCESS: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_RULE',
  DEAL_BUSY: RETRY_SOURCE_ACTION_KEY,
  DEAL_DEADLINE_EXCEEDED: RETRY_SOURCE_ACTION_KEY,
  DEAL_UNAVAILABLE: RETRY_SOURCE_ACTION_KEY,
  DEAL_XML_WORKTIME_UNAVAILABLE: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_BUSY: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_INTERRUPTED: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_DEADLINE_EXCEEDED: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_UNAUTHORIZED: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_FORBIDDEN: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_RATE_LIMITED: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_UNAVAILABLE: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_REQUEST_LIMIT: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_PAGE_LIMIT: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_ITEM_LIMIT: RETRY_SOURCE_ACTION_KEY,
  PLANFIX_RESPONSE_INVALID: RETRY_SOURCE_ACTION_KEY,
  DEAL_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  DEPARTMENT_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  DEPARTMENT_POLICY_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  EMPLOYEE_ASSIGNMENT_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PAYROLL_POSITION_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PAYROLL_GRADE_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  MANUFACTURING_GRADE_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PAYROLL_METHOD_NOT_DEAL: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PLANFIX_NOT_CONFIGURED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PLANFIX_REST_ID_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  SALARY_REQUIRED: 'DEAL_PAYROLL_ISSUE_ACTION_CONFIGURE_PAYROLL',
  PAYROLL_HISTORY_UNAVAILABLE: GENERIC_ACTION_KEY
};

export function dealPayrollBlockerKey(code: string): string {
  return BLOCKER_KEYS[code] || EMPTY_KEY;
}

export function dealPayrollBlockerKeys(codes: string[]): string[] {
  return (codes || [])
    .map((code: string) => dealPayrollBlockerKey(code))
    .filter((key: string, index: number, keys: string[]) => !!key && keys.indexOf(key) === index);
}

export function dealPayrollIssueKey(code: string): string {
  return ISSUE_KEYS[code] || GENERIC_ISSUE_KEY;
}

export function dealPayrollIssueActionKey(code: string): string {
  return ISSUE_ACTION_KEYS[code] || GENERIC_ACTION_KEY;
}

export function dealPayrollIssueEffectKey(issue: DealPayrollIssue): string {
  if (issue && issue.taskId !== null && issue.taskId !== undefined) {
    return EFFECT_NOT_COUNTED_KEY;
  }
  return dealPayrollIssueActionKey(issue && issue.code) === RETRY_SOURCE_ACTION_KEY
    ? EFFECT_SOURCE_UNAVAILABLE_KEY : EFFECT_PAYROLL_UNAVAILABLE_KEY;
}

export function dealPayrollTaskIssueEffectKey(task: DealPayrollTaskLine, code: string): string {
  if (!task || !isFinitePayrollNumber(task.result)) {
    return EFFECT_NOT_COUNTED_KEY;
  }
  return COEFFICIENT_ONE_ISSUE_CODES.indexOf(code) >= FIRST_ISSUE_CODE_INDEX
    ? EFFECT_COUNTED_WITH_ONE_KEY : EFFECT_COUNTED_KEY;
}

export function dealPayrollGradeKey(gradeCode: DealPayrollGradeCode): string {
  return gradeCode ? GRADE_KEY_PREFIX + gradeCode : EMPTY_KEY;
}

export function dealPayrollTaskRuleKey(code: DealPayrollTaskRuleCode): string {
  return code ? TASK_RULE_KEY_PREFIX + code : EMPTY_KEY;
}

export function dealPayrollClassificationSourceKey(code: DealPayrollClassificationSource): string {
  return code ? CLASSIFICATION_SOURCE_KEY_PREFIX + code : EMPTY_KEY;
}

export function dealPayrollCoefficientUnitTypeKey(code: DealPayrollCoefficientUnitType): string {
  return code ? COEFFICIENT_UNIT_TYPE_KEY_PREFIX + code : EMPTY_KEY;
}

export function dealPayrollChecklistKindKey(code: DealPayrollChecklistKind): string {
  return code ? CHECKLIST_KIND_KEY_PREFIX + code : EMPTY_KEY;
}

export function dealPayrollEmployeeRoleKey(code: DealPayrollEmployeeRoleCode): string {
  return code ? EMPLOYEE_ROLE_KEY_PREFIX + code : EMPTY_KEY;
}

export function dealPayrollProfileKey(profile: DealPayrollProfile): string {
  return profile ? PROFILE_KEY_PREFIX + profile : EMPTY_KEY;
}

export function dealPayrollFormulaVersionKey(version: DealPayrollFormulaVersion): string {
  return version ? FORMULA_KEY_PREFIX + version : EMPTY_KEY;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/deal-payroll-presentation.ts